import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { IS_DISABLED, IS_ENABLED, IS_SELECTED } from 'Components/utils/product/product.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
export type ProductComparisonProps = {
  children?: React.ReactNode;
  className?: string;
  eligibilityLabel?: string;
  isEligible?: boolean;
  label?: string;
  status?: 'isSelected' | 'isEnabled' | 'isDisabled';
  onComparisonClick?: () => unknown;
};
export const ProductComparison = ({
  className,
  eligibilityLabel,
  isEligible,
  label,
  onComparisonClick,
  status = IS_ENABLED,
}: ProductComparisonProps) => {
  if (!isEligible) {
    return (
      <div className="absolute inset-0 z-1 flex items-center justify-center rounded-12 bg-white/60 p-20 text-center text-14 font-bold">
        {eligibilityLabel}
      </div>
    );
  }

  const isSelectable = status !== IS_DISABLED;
  const isSelected = status === IS_SELECTED;
  const buttonProps = isSelectable
    ? {
        onClick: onComparisonClick,
        type: 'button' as const,
        title: label,
      }
    : null;
  const TagName = isSelectable ? 'button' : 'div';
  return (
    <TagName
      className={classnames(
        'absolute inset-0 z-1 flex h-full w-full items-center justify-center rounded-12 bg-darkGrey/40 p-20 text-white',
        className,
      )}
      {...buttonProps}
    >
      {isSelectable && (
        <span
          className={classnames(
            'aspect-square rounded-full border-2 p-10 leading-0 transition-colors duration-250 ease-in',
            {
              'border-white bg-transparent': !isSelected,
              'border-saffron bg-saffron text-black': isSelected,
            },
          )}
        >
          <Icon name={isSelected ? ICONS.CHECK : ICONS.PLUS} width="1.25rem" />
        </span>
      )}
    </TagName>
  );
};
